export default "__VITE_ASSET__BICcSc0W__"